import React, { useRef, useEffect, useState } from 'react';
import './Shape.sass';
const Shape = ({ data }) => {
  let shape = useRef();
  /*useEffect(() => {
    const { animations } = data;
    if (!!animations && !!shape) {
      animate(animations, shape);
    }
  }, []);*/
  return (
    <div
      ref={(el) => (shape = el)}
      id={data.id}
      className={`shape ${data.classNames || ''}`}
      style={data.style || {}}
    />
  );
};

export default Shape;
